<script>
import "swiper/swiper-bundle.css";
import Swiper, { Scrollbar } from "swiper";
Swiper.use([Scrollbar]);

export default {
  name: "ClientsScroller",
  mounted() {
    this.swiper = new Swiper(this.$refs.swiper, {
      slidesPerView: "auto",
      freeMode: true,
      spaceBetween: 0,
      scrollbar: {
        el: ".clients-scrollbar",
        draggable: true,
        dragSize: 80,
        hide: false,
      },
      navigation: {
        nextEl: ".clients-next",
        prevEl: ".clients-prev",
      },
    });

    if (this.swiper.isBeginning && this.swiper.isEnd) {
      document.querySelector(".block-clients-bottom").classList.add("hidden");
    } else {
      document.querySelector(".block-clients-bottom").classList.remove("hidden");
    }

    setTimeout(() => {
      this.swiper.scrollbar.init();
      this.swiper.scrollbar.updateSize();
    }, 50)
  },
};
</script>

<template>
  <div class="block-clients-scroll">
    <div ref="swiper" class="swiper-container">
      <div class="swiper-wrapper client-groups">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.block-clients-scroll {
  .swiper-container {
    width: 100%;
  }

  .swiper-wrapper {
  }
}
</style>
